export const recentChecks = [
  {
    clause: "6.2.4.4",
    label: "Zones",
    query: "Can I install a socket outlet near a basin?",
    summary: "Zones, RCD protection, clause references"
  },
  {
    clause: "3.9.4.2",
    label: "Support",
    query: "What support spacing applies to wiring systems?",
    summary: "Cable support and fixing checks"
  },
  {
    clause: "2.6.3.2",
    label: "RCD",
    query: "When do I need additional RCD protection?",
    summary: "Additional protection triggers"
  }
] as const;

